module.exports = __webpack_public_path__ + "img/weixin.08a5193e.png";